import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Book, Layers, MapPin, Ruler } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: Book,
    title: 'Ebook Maestro',
    description: '60 páginas con técnicas pro, la guía Click & Knit y acceso a los +4.500 patrones clasificados.'
  }, {
    icon: Layers,
    title: 'Biblioteca Digital',
    description: 'Acceso directo a patrones de ropa, amigurumis, accesorios y hogar. Todo organizado.'
  }, {
    icon: MapPin,
    title: 'Guía Uruguay',
    description: 'Guía completa de materiales y lanas en Uruguay, con equivalencias y marcas locales.'
  }, {
    icon: Ruler,
    title: 'Adaptación de Talles',
    description: 'Guía experta para adaptar cualquier patrón a tus medidas reales. No más prendas que no entran.'
  }];
  return <section className="py-12 md:py-24 bg-[#FAF7F4]" data-id="element-180">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center mb-8 md:mb-16" data-id="element-182">
          <span className="text-[#C17B5C] font-bold tracking-wider uppercase text-sm mb-1 block" data-id="element-183">
            ¿Qué incluye?
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#3D2B1F] mb-3" data-id="element-184">
            La Biblioteca Total de Crochet 2026
          </h2>
          <p className="text-base md:text-lg text-[#6B5A4E] max-w-2xl mx-auto" data-id="element-185">
            Un sistema completo diseñado para elevar tu nivel de tejido y
            simplificar tu proceso creativo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-186">
          {features.map((feature, index) => <Card key={index} hover className="flex items-start p-5 md:p-8 border-[#EAE0D5] bg-white/80 backdrop-blur-sm" data-id="element-187">
              <div className="w-11 h-11 rounded-2xl bg-[#F5EBE0] flex items-center justify-center text-[#8B7355] flex-shrink-0 mr-4" data-id="element-188">
                <feature.icon className="w-5 h-5" data-id="element-189" />
              </div>
              <div data-id="element-190">
                <h3 className="text-lg md:text-2xl font-bold text-[#3D2B1F] mb-1" data-id="element-191">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-lg text-[#6B5A4E] leading-relaxed" data-id="element-192">
                  {feature.description}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}